import { getEmptyTranslations } from '@/configuration/pages/ConfigurationPage/helpers'

export const getSavePreferencesPayload = ({
  backgroundColor,
  textColor,
  linkColor,
  useCustomTitle,
  useCustomContent,
  useSizeGuide,
  customTexts,
  supportedLanguages,
}) => {
  const emptyTranslations = getEmptyTranslations(supportedLanguages)

  return {
    background_color: backgroundColor,
    text_color: textColor,
    link_color: linkColor,
    content_text: useCustomContent ? customTexts.content : emptyTranslations,
    title_text: useCustomTitle ? customTexts.title : emptyTranslations,
    size_guide_url: useSizeGuide ? customTexts.size_guide_url : null,
  }
}
